import { Input, Textarea } from "@chakra-ui/react";
import { FieldShell, type FieldControlProps } from "./FieldShell";
import { dateRangeForField, formatCurrencyInput } from "../fieldUtils";

export function TextField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <Input
        type={field.field_type === "email" ? "email" : "text"}
        value={value}
        placeholder={field.placeholder ?? ""}
        onChange={(e) => onChange(field.id, e.target.value)}
      />
    </FieldShell>
  );
}

export function TextareaField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <Textarea
        value={value}
        placeholder={field.placeholder ?? ""}
        onChange={(e) => onChange(field.id, e.target.value)}
      />
    </FieldShell>
  );
}

export function NumberField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <Input
        type="number"
        value={value}
        placeholder={field.placeholder ?? ""}
        onChange={(e) => onChange(field.id, e.target.value)}
      />
    </FieldShell>
  );
}

export function CurrencyField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <Input
        value={value ? formatCurrencyInput(value) : ""}
        placeholder={field.placeholder ?? "R$ 0,00"}
        onChange={(e) => {
          const digits = e.target.value.replace(/\D/g, "");
          const num = digits ? (parseInt(digits, 10) / 100).toFixed(2) : "";
          onChange(field.id, num);
        }}
      />
    </FieldShell>
  );
}

export function DateField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  const { min, max } = dateRangeForField(field);
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <Input
        type="date"
        value={value}
        min={min}
        max={max}
        onChange={(e) => onChange(field.id, e.target.value)}
      />
    </FieldShell>
  );
}